import { BasePermissionCapability } from "app/based/baseApiModel/basePermissionMenu/BasePermissionCapability";
import { BasePermissionMenu } from "app/based/baseApiModel/basePermissionMenu/BasePermissionMenu";
import { ReactNode } from "react";

export class FeaturedSideBarEntity extends BasePermissionMenu {
  name?: string;
  key?: string;
  path?: string;
  componentName?: string;
  enable?: boolean;
  icon?: string | ReactNode;
  capabilities?: BasePermissionCapability[];
  sub?: FeaturedSideBarEntity[];
  configuration?: Record<string, unknown>;

  constructor(data?: Partial<FeaturedSideBarEntity>) {
    super();
    this.key = data?.key;
    this.name = data?.name;
    this.path = data?.path;
    this.enable = data?.enable;
    this.componentName = data?.componentName;
    this.icon = data?.icon;
    this.capabilities = data?.capabilities;
    this.sub = data?.sub;
    this.configuration = data?.configuration;
  }

  public isHasMainList(): boolean {
    return super.isHasMainList?.() || false;
  }

  public isHasGeneralList(): boolean {
    return super.isHasGeneralList() || false;
  }

  public validatePermission(featureKey: string[]): string[] {
    return super.validatePermission?.(featureKey) || featureKey;
  }
}
